import { DateTime } from 'luxon'
import { normalizeStoreTimeForInput } from './normalizeStoreTimeForInput'
import { DEFAULT_API_TIME_FORMAT } from './apiDateTimeFormats.constants'

export const formatStoreTime = (value?: string | null, format = DEFAULT_API_TIME_FORMAT) => {
  const normalized = normalizeStoreTimeForInput(value)
  if (!normalized) return 'N/A'

  const time = DateTime.fromFormat(normalized, 'HH:mm')
  if (!time.isValid) return normalized

  return time.toFormat(format)
}
